import React, { useEffect, useState } from "react";
import { Switch, message } from "antd";
import api from "../utils/apiClient";
import "../style/EmailPrefs.css";

const LABELS = {
  boletines: {
    titulo: "Boletines",
    detalle: "Inventario semanal y subastas próximas",
  },
  subastaSuperado: {
    titulo: "Te superaron",
    detalle: "Cuando otra oferta pasa la tuya en una subasta",
  },
  subastaGanador: {
    titulo: "Ganaste una subasta",
    detalle: "El aviso con los pasos para reclamar tu compra",
  },
};

// Per-user email opt-outs. Each toggle saves immediately; the backend enforces
// these at every send, and the in-app notifications are never affected.
function EmailPrefs() {
  const [prefs, setPrefs] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api
      .get("usuario/emailprefs")
      .then((res) => { if (!cancelled) setPrefs(res.data); })
      .catch(() => { if (!cancelled) setPrefs(null); });
    return () => { cancelled = true; };
  }, []);

  if (!prefs) return null;

  const toggle = async (key, value) => {
    const prev = prefs;
    setPrefs({ ...prefs, [key]: value });
    setSaving(true);
    try {
      const res = await api.put("usuario/emailprefs", { [key]: value });
      setPrefs(res.data);
    } catch (error) {
      setPrefs(prev);
      message.error("No se pudo guardar la preferencia");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="email-prefs">
      <p className="email-prefs-title">Correos que quieres recibir</p>
      {Object.keys(LABELS).map((key) => (
        <div className="email-prefs-row" key={key}>
          <div className="email-prefs-labels">
            <span className="email-prefs-name">{LABELS[key].titulo}</span>
            <span className="email-prefs-detail">{LABELS[key].detalle}</span>
          </div>
          <Switch
            checked={prefs[key]}
            disabled={saving}
            onChange={(v) => toggle(key, v)}
          />
        </div>
      ))}
    </div>
  );
}

export default EmailPrefs;
